import React from 'react';

import { StudiesPage } from './StudiesPage';

export const StudiesController: React.FC = () => {
  return <StudiesPage />;
};
